<zwi-embed-sermon-list-container>
  @for (series of series | keyvalue; track series) {
    <div>
      <zwi-sermon-category-row class="zwi-series-sermons-category">{{ series.key }}</zwi-sermon-category-row>
      @for (s of series.value; track s.id) {
        <zwi-sermon-list-item [active]="sermonService.sermon().id === s.id" [order]="s.orderInSeries"  [sermon]="s" (click)="emitSelectedSermon(s)"></zwi-sermon-list-item>
      }
    </div>
  }
</zwi-embed-sermon-list-container>

